import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


export function ToastMsg(msg, msgType) {
  const message =msgType==="success"?"Success": msg?msg:"something went wrong";
  return msgType === "success"
    ? toast.success(`${msg||message}`, {
        position: "top-center",
        autoClose: 2500,
        hideProgressBar: false,
 
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      })
    : toast.error(`${msg||message}`, {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      });
}